import log from "./log";

export class BikehubUtilities {
  enableEscapeForModals() {
    window.escapeForModalsEnabled = false;
    $(".modal").on("show.bs.modal", () => {
      if (window.escapeForModalsEnabled) {
        return true;
      }
      window.escapeForModalsEnabled = true;
      $(window).on("keyup", function(e) {
        if (e.keyCode === 27) {
          // Hide last modal - if there are overlapping modals, the last is the visible one
          $(".modal.show")
            .last()
            .modal("hide"); // Escape key
          // If there have been multiple
          if ($(".modal.show").length === 0) {
            $(window).off("keyup");
            window.escapeForModalsEnabled = false;
          }
        }
        return true;
      });
    });
    // Remove keyup trigger, clean up after yourself
    $(".modal").on("hide.bs.modal", () => {
      // Only remove it if there are no more active modals
      if ($(".modal.show").length === 0) {
        $(window).off("keyup");
        window.escapeForModalsEnabled = false;
      }
    });
  }

  displayAlertIfUnpermittedExtension(filename, $form) {
    // If there aren't defined permitted extensions, don't alert
    if (!window.permittedExtensions) {
      return;
    }
    let ext = filename.match(/\.[^\.]+$/g);
    // Get the first match, lowercase, remove the period
    ext = ext && ext[0].toLocaleLowerCase().substring(1);
    // If extension is blank, let the server handle it.
    // And if it's a permitted extension, don't alert
    if (!ext || window.permittedExtensions.includes(ext)) {
      return;
    }
    const msg = `The file you selected is not a permitted format. Permitted formats are: ${window.permittedExtensionsDisplay}`;
    // Use the bikeHubFormValidator if it's around, otherwise alert
    if (!!window.bikeHubFormValidator && $form.length) {
      window.bikeHubFormValidator.renderFormErrors($form, [msg]);
    } else {
      alert(msg);
    }
  }

  enableFilenameForUploads() {
    const displayAlertIfUnpermittedExtension = this
      .displayAlertIfUnpermittedExtension;

    $("input.custom-file-input[type=file]").on("change", function(e) {
      // Clear form error (if they tried an unsupported format)
      const $form = $(".jsValidated");
      if ($form.length) {
        $form.find(".formErrors").collapse("hide");
      }

      // The issue is that the files list isn't actually an array. So we can't map it
      let files = [];
      let i = 0;
      while (i < e.target.files.length) {
        files.push(e.target.files[i].name);
        i++;
      }

      $(this)
        .parent()
        .find(".custom-file-label")
        .text(files.join(", "));

      if (permittedExtensions.length) {
        files.forEach(f => displayAlertIfUnpermittedExtension(f, $form));
      }
    });
  }

  enableFullscreenOverflow() {
    const pageWidth = $(window).width();
    $(".full-screen-table table").each(function(index) {
      const $this = $(this);
      if ($this.outerWidth() > pageWidth) {
        $this
          .parents(".full-screen-table")
          .addClass("full-screen-table-overflown");
      }
    });
  }

  init() {
    this.enableEscapeForModals();
    this.enableFilenameForUploads();
    this.enableFullscreenOverflow();
    // Add tooltips
    $(".tooltip-question").tooltip()
  }
}
